import { CHANGE_LOAD } from "./store/actions/load"
import { SPLICE_ERRO } from "./store/actions/alert_api"

export default (axios, store) => {

    axios.interceptors.request.use(req => {
        store.commit(CHANGE_LOAD, true)
        return req;
    },
        error => {
            store.commit(CHANGE_LOAD, false)
            return Promise.reject(error)
        }
    )

    axios.interceptors.response.use(res => {
        store.commit(CHANGE_LOAD, false)
        return res;
    },
        error => {
            const status = error.response?.status

            if (status === 401) {
                store.dispatch('auth/logout')
            }

            const serverMessage = error.response?.data?.error?.message
            if (serverMessage) {
                error.message = serverMessage
                store.commit(SPLICE_ERRO, { alert: serverMessage, type: 'E' })
            }

            store.commit(CHANGE_LOAD, false)
            return Promise.reject(error)
        }
    )
}
